'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizationHelper = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

var _Router = require('../helpers/Router');

var _Login = require('../helpers/Login');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorizationHelper = exports.AuthorizationHelper = (_temp = _class = function AuthorizationHelper() {
  (0, _classCallCheck3.default)(this, AuthorizationHelper);
}, _class.authorizeNowPath = function (provider) {
  var path = _Router.RouterConst.AuthorizationNow;
  if (provider.loginMode.find(function (loginMode) {
    return loginMode === _Login.LoginMode.SSO;
  }) && provider.loginUrlWithRedirect) {
    path = _Router.RouterConst.AuthorizationOptions;
  }

  return path;
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Authorization.js
// module id = 411
// module chunks = 0